// extracted by mini-css-extract-plugin
export var lg = "_d4-7";
export var md = "_d4-6";
export var placeholderContainer = "_d4-1";
export var placeholderIcon = "_d4-2";
export var productImage = "_d4-0";
export var sm = "_d4-5";
export var xl = "_d4-8";
export var xs = "_d4-4";
export var xxs = "_d4-3";